import { render, staticRenderFns } from "./customerVehicle.vue?vue&type=template&id=19094e36&"
import script from "./customerVehicle.vue?vue&type=script&lang=js&"
export * from "./customerVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports